import { MEETING_EVENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
import { ACTIVITY_FILTERS } from '../../permissions/gates';
const MeetingEvent = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated(ACTIVITY_FILTERS),
  objectTypeId: MEETING_EVENT_TYPE_ID,
  referenceObjectType: 'MEETING_EVENT_PROPERTIES'
});
export default MeetingEvent;